// extracted by mini-css-extract-plugin
export default {"translation-detector":"textChangeTranslateDetector_translation-detector__f-3Hg"};